import * as React from 'react';

function SvgPlus(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
      <defs>
        <clipPath id="plus_svg__clip-path">
          <path
            id="plus_svg__Rectangle_367"
            d="M0 0h20v20H0z"
            data-name="Rectangle 367"
            transform="translate(116 754)"
            stroke="#707070"
            fill={`${props.fill}`}
          />
        </clipPath>
        <style>{`.plus_svg__cls-3{fill:${props.fill}}`}</style>
      </defs>
      <g
        id="plus_svg__plus_point_system"
        transform="translate(-116 -754)"
        clipPath="url(#plus_svg__clip-path)"
      >
        <g id="plus_svg__Group_248" data-name="Group 248" transform="translate(-203 653)">
          <path
            id="plus_svg__Rectangle_365"
            d="M0 0h20v2.667H0z"
            className="plus_svg__cls-3"
            data-name="Rectangle 365"
            transform="translate(319 109.667)"
          />
          <path
            id="plus_svg__Rectangle_366"
            d="M0 0h20v2.667H0z"
            className="plus_svg__cls-3"
            data-name="Rectangle 366"
            transform="rotate(90 114.666 215.667)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgPlus;
